import React, { memo } from 'react';
import './footer-container.scss';

const FooterContainer = () => {
  return (
    <div className='on-footer'>
       <footer className="bt-footer" data-cy="footer">
        <div className="px--safe">
          <div className="container uk-text-small">
            <div className="grid grid--gutters">
              <div className="cell cell-xs-12 cell-md-3 cell-lg-2">
                <h3 className="bt-footer-widget__title">Guides</h3>
                <ul className="uk-list">
                  <li>
                    <a
                      className="js-footer-guides"
                      href="https://www.strockrealestate.com/guide/aptos/"
                    >
                      Aptos
                    </a>
                  </li>
                  <li>
                    <a
                      className="js-footer-guides"
                      href="https://www.strockrealestate.com/guide/santa-cruz/"
                    >
                      Santa Cruz
                    </a>
                  </li>
                  <li>
                    <a
                      className="js-footer-guides"
                      href="https://www.strockrealestate.com/guide/rio-del-mar/"
                    >
                      Rio Del Mar
                    </a>
                  </li>
                  <li>
                    <a
                      className="js-footer-guides"
                      href="https://www.strockrealestate.com/guide/soquel/"
                    >
                      Soquel
                    </a>
                  </li>
                  <li>
                    <a
                      className="js-footer-guides"
                      href="https://www.strockrealestate.com/guide/seacliff/"
                    >
                      Seacliff
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.strockrealestate.com/guides/"
                      className="bt-more-bounce js-footer-guides"
                    >
                      More Guides <i className="fas fa-fw fa-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="cell cell-xs-12 cell-md-3 cell-lg-2">
                <div
                  id="custom_html-9"
                  className="widget_text widget widget_custom_html section"
                >
                  <h3 className="widget-title">Company</h3>
                  <div className="textwidget custom-html-widget">
                    <ul>
                      <li>
                        <a
                          href="https://www.strockrealestate.com/agents/"
                          title="Meet the Team"
                        >
                          Meet the Team
                        </a>
                        <br />
                      </li>
                      <li>
                        <a
                          href="https://www.strockrealestate.com/blog/"
                          title="Our Blog"
                        >
                          Our Blog
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.strockrealestate.com/contactus/"
                          title="Our Blog"
                        >
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="cell cell-xs-12 cell-md-3 cell-lg-2">
                <h3 className="bt-footer-widget__title">Resources</h3>
                <ul className="uk-list">
                  <li>
                    <a
                      className="js-footer-buyhome"
                      href="https://www.strockrealestate.com/buy/"
                      title="Buy a home in Conejo Valley"
                    >
                      Buy a Home
                    </a>
                  </li>
                  <li>
                    <a
                      className="js-footer-sellhome"
                      href="https://www.strockrealestate.com/sell/"
                      title="Sell homes in Conejo Valley"
                    >
                      Sell Your Home
                    </a>
                  </li>
                  <li>
                    <a
                      className="js-footer-finance"
                      href="https://www.strockrealestate.com/finance/"
                      title="Finance your dream home in Conejo Valley"
                    >
                      Finance
                    </a>
                  </li>
                </ul>
              </div>
              <div className="cell cell-xs-12 cell-md-3 cell-lg-2">
                <h3 className="bt-footer-widget__title">Get Social</h3>
                <div className="bt-social-icons js-footer-social-icons">
                  <a
                    href="#"
                    target="_blank"
                    aria-label="rss"
                    title="rss"
                    className="bt-icon__button bt-icon--rss js-footer-social-rss"
                  >
                    <i className="fas fa-fw fa-rss"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/StrockRealEstate/"
                    target="_blank"
                    aria-label="facebook"
                    title="facebook"
                    className="bt-icon__button bt-icon--facebook"
                  >
                    <i className="fab fa-fw fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/strock-real-estate/"
                    target="_blank"
                    aria-label="linkedin"
                    title="linkedin"
                    className="bt-icon__button bt-icon--linkedin"
                  >
                    <i className="fab fa-fw fa-linkedin-in"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCLKQVaMNZhhkwxlFlbAZGJA"
                    target="_blank"
                    aria-label="youtube"
                    title="youtube"
                    className="bt-icon__button bt-icon--youtube"
                  >
                    <i className="fab fa-fw fa-youtube"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/strock_realestate/"
                    target="_blank"
                    aria-label="instagram"
                    title="instagram"
                    className="bt-icon__button bt-icon--instagram"
                  >
                    <i className="fab fa-fw fa-instagram"></i>
                  </a>
                </div>
              </div>

              <div className="cell cell-xs-12 cell-lg-4">
                <div className="js-global-footer-about">
                  <h3 className="bt-footer-widget__title">About Us</h3>
                  <div className="js-global-footer-about-tag">
                    <p>
                      Strock Real Estate is Santa Cruz County's most innovative real estate team.
                    </p>
                  </div>
                </div>
                <address className="js-global-footer-address">
                  <p>
                    DRE License #01337838
                    <br />
                    Strock Real Estate
                  </p>
                  <p>251-A Center Ave., Aptos, CA 95003</p>
                </address>
                <a class="uk-link-muted js-global-footer-phone" href="tel:831.688.9800" title="Give us a call">
                  <i class="fa fa-fw fas fa-phone"></i>
                  <span itemprop="telephone" content="831.688.9800"> 831.688.9800</span>
                </a>
              </div>
            </div>
            <div
              className="mt-15 bt-disclaimer-bottom js-footer-bottom-links"
              data-cy="footer__disclaimer"
            >
              <p className="mb-5">
                <br />
                <br />
                <img style={{border: "0pt none", float:"left", paddingRight:"10px", paddingBottom:"0px"}} src="https://static.boomtownroi.com/content/photos/siliconv/idx/idx-small.gif"></img>
                © 2021 MLSListings Inc. ased on information from MLSListings MLS as of 2021-02-02T23:48:05.763.
                All data, including all measurements and calculations of area, is obtained from various sources and has not been, 
                and will not be, verified by broker or MLS. 
                All information should be independently reviewed and verified for accuracy.
                Properties may or may not be listed by the office/agent presenting the information. 
                DX information is provided exclusively for consumers' personal, non-commercial use and may not be used for 
                any purpose other than to identify prospective properties consumers may be interested in purchasing. 
                Information is deemed reliable but is not guaranteed accurate by the MLS or Strock Real Estate.
                <br />
                <br />
                Licensed in the State of California.
              </p>
            </div>
          </div>
        </div>
        <nav className="bt-footer-aux py-10 px--safe">
          <div className="container">
            <ul className="uk-subnav uk-subnav-line bt-disclaimer-menu mb-0">
              <li className="bt-disclaimer-menu__copyright">
                <a
                  target="_blank"
                  href="https://boomtownroi.com?utm_campaign=lydiagable.com&amp;utm_medium=bt_client_site_referral&amp;utm_source=client_sites"
                  rel="nofollow"
                  title="BoomTown © 2021"
                >
                  © 2021{" "}
                </a>
              </li>
              <li>
                <a href="https://www.lydiagable.com/terms/">Terms of Use</a>
              </li>
              <li>
                <a href="https://www.lydiagable.com/privacy/">Privacy Policy</a>
              </li>
              <li>
                <a href="https://www.lydiagable.com/accessibility/">
                  Accessibility
                </a>
              </li>
              <li>
                <a href="https://www.lydiagable.com/dmca/">DMCA</a>
              </li>
              <li>
                <a href="https://www.lydiagable.com/sitemap/">
                  Listings Sitemap
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </footer>
    </div>
  );
};

export default memo(FooterContainer);
